import React from 'react';
import { StyleSheet, Text, View } from './components/base_components';

import { BusyOverlay, useBusy } from './components/busy_component';
import Breadcrumb from './components/breadcrumb';
import ProgressSpinner from './components/progress_spinner';
import OrgTabBar from './components/org_tab_bar';
import StandardBoxList from './components/standard_box_list';
import TextButton from './components/buttons/text_button';
import LinkTextButton from './components/buttons/link_text_button';

import OrgStore from './stores/org_store';
import PaymentMethodStore from './stores/payment_method_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  orgPaymentScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  spinner: { margin: '3rem', alignSelf: 'center' },
  tabBar: { marginLeft: '2.2rem', marginRight: '2.2rem' },
  actionButton: { marginLeft: '1rem' },
  dialog: { marginLeft: '2rem', marginBottom: '2rem', flexDirection: 'column' },
  text: { marginTop: '1em', fontSize: '1.5em' },
});

export default function OrgPaymentScreen() {
  const [is_busy, setBusy, clearBusy] = useBusy();
  const org_id = UserStore.useOrg()?.org_id;
  const org = OrgStore.useOrg(org_id);
  const method_list = PaymentMethodStore.useList(org_id);
  const [selected, setSelected] = React.useState([]);
  const selected_method = method_list?.[selected[0] ?? -1];

  React.useEffect(() => {
    OrgStore.fetch(org_id);
    PaymentMethodStore.fetch(org_id);
  }, [org_id]);

  function _onDefaultPress() {
    if (selected_method && setBusy()) {
      const { payment_method_id } = selected_method;
      PaymentMethodStore.updateDefault({ org_id, payment_method_id }, (err) => {
        clearBusy();
        if (err) {
          window.alert('Failed to set default method, please try again.');
        }
      });
    }
  }
  function _onDeletePress() {
    if (selected_method && setBusy()) {
      const { payment_method_id } = selected_method;
      PaymentMethodStore.deleteMethod({ org_id, payment_method_id }, (err) => {
        clearBusy();
        if (err) {
          window.alert('Failed to set delete method, please try again.');
        }
      });
    }
  }

  let content: any = null;
  if (!org) {
    content = <ProgressSpinner style={styles.spinner} color='#555' />;
  } else {
    const buttons = (
      <>
        <LinkTextButton
          style={styles.actionButton}
          text='Add Method'
          url={`/org/payment/add`}
        />
        <TextButton
          style={styles.actionButton}
          text='Make Default'
          disabled={!selected_method || selected_method?.is_default}
          onPress={_onDefaultPress}
        />
        <TextButton
          style={styles.actionButton}
          type='danger'
          text='Delete'
          disabled={!selected_method || selected_method?.is_default}
          onPress={_onDeletePress}
        />
      </>
    );

    const rows =
      method_list?.map?.((method, i) => [
        `${method.card_brand} •••• ${method.card_last4}`,
        `${method.exp_month}/${method.exp_year}`,
        method.is_default ? 'Default' : 'Backup',
      ]) ?? [];

    let empty: any = null;
    if (rows.length === 0) {
      empty = (
        <View style={styles.dialog}>
          <Text style={styles.text}>No payment methods found.</Text>
        </View>
      );
    }
    content = (
      <>
        <Breadcrumb
          list={[{ text: org?.org_name, url: `/org` }, 'Payment Methods']}
        />
        <OrgTabBar style={styles.tabBar} />
        <StandardBoxList
          title='Payment Methods'
          headers={['Card', 'Expiration', 'Status']}
          buttons={buttons}
          rows={rows}
          singleSelect={true}
          selected={selected}
          onChange={setSelected}
        >
          {empty}
        </StandardBoxList>
      </>
    );
  }
  return (
    <View style={styles.orgPaymentScreen}>
      {content}
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
